import React from 'react';
import NotificationTemplateForm from 'features/crm/components/notification-templates/NotificationTemplateForm';
import ItemSelector from 'shared/ui/ItemSelector';
import List from 'shared/ui/List';
import ClientItem from 'features/parties/components/clients/ClientItem';
import { useLayout } from 'shared/contexts/LayoutContext';
import { clientService } from 'features/parties/api';
const formatDate = (date) => (date ? new Date(date).toLocaleDateString() : '—');


const ClientsList = (props) => {
  const { openModal } = useLayout();

  const filterOptions = [
    {
      key: 'last_sale__gte',
      label: 'Последняя продажа (с)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'last_sale__lt',
      label: 'Последняя продажа (до)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'last_notification__gte',
      label: 'Последнее уведомление (с)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'last_notification__lt',
      label: 'Последнее уведомление (до)',
      field: ({ value, onChange, className }) => (
        <input
          type='date'
          value={value}
          className={className}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
      initialValue: '',
    },
    {
      key: 'bonus_balance__gte',
      label: 'Минимальный бонусный баланс',
      field: ({ value, onChange, className }) => (
        <input
          type='number'
          step='0.01'
          value={value}
          className={className}
          onChange={(e) => onChange(parseFloat(e.target.value))}
        />
      ),
      initialValue: '',
    },
    {
      key: 'bonus_balance__lt',
      label: 'Максимальный бонусный баланс',
      field: ({ value, onChange, className }) => (
        <input
          type='number'
          step='0.01'
          value={value}
          className={className}
          onChange={(e) => onChange(parseFloat(e.target.value))}
        />
      ),
      initialValue: '',
    },
    {
      key: 'bonus_spent__gt',
      label: 'Минимально потрачено бонусов',
      field: ({ value, onChange, className }) => (
        <input
          type='number'
          step='0.01'
          value={value}
          className={className}
          onChange={(e) => onChange(parseFloat(e.target.value))}
        />
      ),
      initialValue: '',
    },
    {
      key: 'bonus_spent__lt',
      label: 'Максимально потрачено бонусов',
      field: ({ value, onChange, className }) => (
        <input
          type='number'
          step='0.01'
          value={value}
          className={className}
          onChange={(e) => onChange(parseFloat(e.target.value))}
        />
      ),
      initialValue: '',
    },
    {
      key: 'clientgroup',
      label: 'Группа',
      field: ({ value, onChange, className }) => (
        <ItemSelector
          targetUrl='/parties/admin-api/client-groups'
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите группу клиентов'
          searchPlaceholder='Поиск группы клиентов...'
          noItemsFoundText='Группы клиентов не найдены'
          isMultiSelect={true}
        />
      ),
      initialValue: props.clientgroup ? [props.clientgroup] : [],
    },
    {
      key: 'service',
      label: 'Мобильный оператор',
      field: ({ value, onChange, className }) => (
        <ItemSelector
          options={[
            { id: 'beeline', name: 'Билайн' },
            { id: 'o', name: 'О' },
            { id: 'megacom', name: 'Мегаком' },
          ]}
          onSelect={(item) => onChange([...value, item])}
          onRemove={(id) => onChange(value.filter((item) => item.id !== id))}
          selectedItems={value}
          placeholder='Выберите мобильного оператора'
          searchPlaceholder='Поиск...'
          noItemsFoundText='Операторы не найдены'
          isMultiSelect={true}
        />

      ),
      initialValue: [],
    },
    {
      key: 'is_token_active',
      label: 'Токен активен',
      field: ({ value, onChange, className }) => (
        <select
          value={value === null ? '' : value.toString()}
          className={className}
          onChange={(e) => {
            const val = e.target.value;
            onChange(val === '' ? null : val === 'true');
          }}
        >
          <option value=''>Все</option>
          <option value='true'>Да</option>
          <option value='false'>Нет</option>
        </select>
      ),
      initialValue: null,
    }
  ];

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Имя' },
    { key: 'phone', label: 'Телефон' },
    { key: 'bonus_balance', label: 'Бонусный баланс', component: (item) => <>{item.bonus_balance.toFixed(2)}</> },
    { key: 'bonus_spent', label: 'Потрачено бонусов', component: (item) => <>{item.bonus_spent.toFixed(2)}</> },
    {
      key: 'doc__count',
      label: 'Количество документов',
      component: (item) => <>{item.docs?.meta.size}</>
    },
    { key: 'last_sale', label: 'Последняя продажа', component: (item) => <>{formatDate(item.last_sale)}</> },
    { key: 'last_notification', label: 'Последнее уведомление', component: (item) => <>{formatDate(item.last_sms)}</> },
    { key: 'gender', label: 'Пол', component: (item) => <>{item.gender}</> },
    { key: 'created', label: 'Создано', component: (item) => <>{formatDate(item.created)}</> },
    { key: 'updated', label: 'Обновлено', component: (item) => <>{formatDate(item.updated)}</> },
  ];

  const handleSendNotification = (queryString, token, { showToast, setIsLoading }) => {
    const NotificationModal = () => {
      const [selectedTemplate, setSelectedTemplate] = React.useState(null);
      const [isCreatingNew, setIsCreatingNew] = React.useState(false);
      const { closeModal } = useLayout();

      const handleSend = async (templateId) => {
        try {
          setIsLoading(true);
          const response = await clientService.sendNotification(queryString, token, templateId);
          showToast({
            title: 'Успех!',
            content: response.message || 'Уведомление успешно отправлено.',
            type: 'success'
          });
          closeModal();
        } catch (error) {
          console.log('Error sending notification:', error);
          showToast({
            title: 'Ошибка!',
            content: error.message || 'Не удалось отправить уведомление.',
            type: 'error'
          });
        } finally {
          setIsLoading(false);
        }
      };

      if (isCreatingNew) {
        return (
          <div>
            <button
              onClick={() => setIsCreatingNew(false)}
              className='mb-4 text-blue-500 hover:text-blue-700 flex items-center gap-1'
            >
              ← Назад к выбору шаблона
            </button>
            <NotificationTemplateForm
              onSuccess={(template) => handleSend(template.id)}
            />
          </div>
        );
      }

      return (
        <div className='p-6 bg-white space-y-6'>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Выберите существующий шаблон
            </label>
            <ItemSelector
              targetUrl='/crm/admin-api/notification-templates'
              onSelect={(item) => setSelectedTemplate(item)}
              onRemove={() => setSelectedTemplate(null)}
              selectedItems={selectedTemplate ? [selectedTemplate] : []}
              placeholder='Выберите шаблон уведомления'
              searchPlaceholder='Поиск шаблона...'
              noItemsFoundText='Шаблоны не найдены'
              isMultiSelect={false}
            />
          </div>

          <div className='flex items-center gap-4'>
            <div className='flex-1 border-t border-gray-200'></div>
            <span className='text-gray-500 text-sm'>или</span>
            <div className='flex-1 border-t border-gray-200'></div>
          </div>

          <button
            onClick={() => setIsCreatingNew(true)}
            className='w-full px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-400 hover:text-blue-500 transition-colors'
          >
            + Создать новый шаблон
          </button>

          <div className='flex justify-end gap-3 pt-4 border-t'>
            <button
              onClick={closeModal}
              className='px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50'
            >
              Отмена
            </button>
            <button
              onClick={() => handleSend(selectedTemplate?.id)}
              disabled={!selectedTemplate}
              className='px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed'
            >
              Отправить уведомление
            </button>
          </div>
        </div>
      );
    };

    openModal({
      component: <NotificationModal />,
      title: 'Отправить уведомление',
    });
  };

  const actions = [
    {
      key: 'send_notification',
      label: 'Отправить уведомление',
      action: handleSendNotification,
    }
  ];
  return (
    <List
      targetUrl={props.targetUrl || '/parties/admin-api/clients'}
      filterOptions={filterOptions}
      columns={columns}
      ItemComponent={ClientItem}
      actions={actions}
    />
  );
};
export default ClientsList;
